const Slot = {

    // FIELDS
    "slot_name": "Slot Name",
    "max_normal_seat": "Max Normal Seat",
    "max_premium_seat": "Max Premium Seat",
    "slot_type": "Slot Type",
    "normal_seat_price": "Normal Seat Price",
    "premium_seat_price": "Premium Seat Price",
    "slot_price": "Slot Price",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "slot": "Slot",

    // ERROR
    "error_name": "Enter Slot Name",
    "error_max_normal_seat": "Enter Max Normal Seat",
    "error_max_premium_seat": "Enter Max Premium Seat",
    "error_slot_type": "Enter Slot Type",
    "error_normal_seat_price": "Enter Normal Seat Price",
    "error_premium_seat_price": "Enter Premium Seat Price",
    "error_slot_price": "Add at least one Slot Price",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": "SLOT NAME",
    "table_max_normal_seat": "MAX NORMAL SEAT",
    "table_max_premium_seat": "MAX PREMIUM SEAT",
    "table_status": "STATUS",

}

export default Slot;
